import { BasketItem } from "../models/BasketItem";
// import { gaEvent } from "./ga";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga4";
import {
  pushAddToCartEventGTM,
  pushBeginCheckoutEventGTM,
  pushPrePurchaseEventGTM,
  pushPurchaseEventGTM,
  pushRemoveFromCartEventGTM,
  pushViewCartEventGTM
} from "./gtm";

export const addToCart = (basket: BasketItem[], categoryBrand: string, totalBasket: number) => {
  const items = basket.map((item: BasketItem) => ({
    item_id: item.assortIds,
    item_name: item.assortName,
    item_brand: categoryBrand,
    item_category: "Bilety okresowe",
    price: item.price,
    quantity: item.qnt
  }));
  const item = {
    currency: "PLN",
    value: totalBasket,
    items
  };
  //wyłączam gaEvent na porśbe Julinka
  // gaEvent("product", "add_to_cart", item, "add to cart");

  ReactPixel.track("AddToCart", item);
  // ReactGA.ga("event", "conversion", {
  //   send_to: "AW-10936866356/-dB8CNTsypQYELSsjd8o",
  //   value: totalBasket,
  //   currency: "PLN"
  // });

  pushAddToCartEventGTM(totalBasket, "PLN", items);
};

export const viewCart = (basket: BasketItem[], categoryBrand: string, totalBasket: number) => {
  const items = basket.map((item: BasketItem) => ({
    item_id: item.assortIds,
    item_name: item.assortName,
    item_brand: categoryBrand,
    item_category: "Bilety okresowe",
    price: item.price,
    quantity: item.qnt
  }));
  const item = {
    currency: "PLN",
    value: totalBasket,
    items
  };

  // gaEvent("product", "view_cart", item, "view cart");
  ReactPixel.track("view_cart", item);
  ReactGA.ga("event", "conversion", {
    send_to: "AW-10936866356/-dB8CNTsypQYELSsjd8o",
    value: totalBasket,
    currency: "PLN"
  });
  pushViewCartEventGTM(totalBasket, "PLN", items);
};

export const removeFromCart = (basket: BasketItem[], categoryBrand: string, totalBasket: number) => {
  const items = basket.map((item: BasketItem) => ({
    item_id: item.assortIds,
    item_name: item.assortName,
    item_brand: categoryBrand,
    item_category: "Bilety okresowe",
    price: item.price,
    quantity: item.qnt
  }));
  const item = {
    currency: "PLN",
    value: totalBasket,
    items
  };

  // gaEvent("product", "remove_from_cart", item, "remove from cart");
  ReactPixel.track("remove_from_cart", item);
  pushRemoveFromCartEventGTM(totalBasket, "PLN", items);
};

export const beginCheckout = (basket: BasketItem[], categoryBrand: string, coupon: string) => {
  const total = basket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);
  const items = basket.map((item: BasketItem) => ({
    item_id: item.assortIds,
    item_name: item.assortName,
    item_brand: categoryBrand,
    item_category: "Bilety okresowe",
    price: item.price,
    quantity: item.qnt
  }));
  const item = {
    currency: "PLN",
    value: total,
    coupon,
    items
  };
  // console.log("begin_checkout", item);
  //
  // gaEvent("product", "begin_checkout", item, "begin checkout");
  ReactPixel.track("InitiateCheckout", item);
  pushBeginCheckoutEventGTM(total, "PLN", items, coupon);
};

export const addPaymentInfo = (basket: BasketItem[], categoryBrand: string, coupon: string) => {
  const total = basket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);
  const items = basket.map((item: BasketItem) => ({
    item_name: item.assortName,
    item_brand: categoryBrand,
    item_category: "Bilety okresowe",
    price: item.price,
    discount: 0,
    quantity: item.qnt,
    coupon: item.promotionCode
  }));
  const item = {
    currency: "PLN",
    value: total,
    coupon,
    payment_type: "PayU",
    items
  };
  // console.log("add_payment_info", item);
  //
  // gaEvent("product", "add_payment_info", item, "add payment info");
  ReactPixel.track("AddPaymentInfo", item);
  ReactGA.ga("event", "conversion", {
    send_to: "AW-10936866356/QHmACKimgsgDELSsjd8o",
    value: total,
    currency: "PLN"
  });
};

export const purchase = (transaction_id: string, value: number, items: any[]) => {
  const coupon = "";
  const item = {
    transaction_id,
    currency: "PLN",
    value,
    coupon: "",
    payment_type: "PayU",
    items
  };

  // gaEvent("product", "purchase", item, "purchase");
  ReactPixel.track("Purchase", item);
  ReactGA.ga("event", "conversion", {
    send_to: "AW-10936866356/QHmACKimgsgDELSsjd8o",
    value,
    currency: "PLN"
  });
  pushPurchaseEventGTM(value, "PLN", items, coupon, transaction_id);
};

export const prePurchase = (transaction_id: string, value: number, items: any[]) => {
  const coupon = "";
  pushPrePurchaseEventGTM(value, "PLN", items, coupon, transaction_id);
};
